<mat-sidenav-container class="sidebar">
    <!-- <mat-sidenav #leftMenuRef mode="side" opened="true"> -->
    <mat-sidenav #leftMenuRef [mode]="uiStore.isMobile ? 'over' : 'side'" [opened]="!uiStore.isMobile">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="m-1 text-uppercase">Dashboard</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="nav nav-pills flex-column mb-auto mx-n3">
                    <li>
                        <a routerLink="/admin/reports" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>analytics</mat-icon>
                            <span class="m-1">Reports</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/feedback" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>rate_review</mat-icon>
                            <span class="m-1">User Feedback</span>
                        </a>
                    </li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="m-1 text-uppercase">Configuration</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="nav nav-pills flex-column mb-auto mx-n3">
                    <li>
                        <a routerLink="/admin/approach-profiles" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>perm_contact_calendar</mat-icon>
                            <span class="m-1">Approach Profiles</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/attestations" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>article</mat-icon>
                            <span class="m-1">Attestations</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/templates" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>description</mat-icon>
                            <span class="m-1">File Templates</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/notification-templates" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>notifications</mat-icon>
                            <span class="m-1">Notification Templates</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/pdf-user-guides" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>picture_as_pdf</mat-icon>
                            <span class="m-1">PDF User Guides</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/teaching-fields" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>article</mat-icon>
                            <span class="m-1">Teaching Fields</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/user-guides" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>menu_book</mat-icon>
                            <span class="m-1">User Guides</span>
                        </a>
                    </li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="m-1 text-uppercase">Renewals</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="nav nav-pills flex-column mb-auto mx-n3">
                    <li>
                        <a routerLink="/admin/renewal-users" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>group</mat-icon>
                            <span class="m-1">Renewal Users</span>
                        </a>
                    </li>
                </ul>
            </mat-expansion-panel>
            <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="m-1 text-uppercase">Stipend</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="nav nav-pills flex-column mb-auto mx-n3">
                    <li>
                        <a routerLink="/admin/stipend-eligibility" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>school</mat-icon>
                            <span class="m-1">Eligibility</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="/admin/leadership-config" class="nav-link" [routerLinkActive]="'active'">
                            <mat-icon>settings</mat-icon>
                            <span class="m-1">Configuration</span>
                        </a>
                    </li>
                </ul>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-sidenav>
    <mat-sidenav-content autosize>
        <!-- <button mat-raised-button (click)="leftMenuRef.toggle()">Toggle drawer</button> -->
        <app-breadcrumb></app-breadcrumb>
        <div class="px-3">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>